import Vue from 'vue';
import * as types from '../mutation-types';


// initial state
const state = {
  fancyBusy: false,
  fancyOffset: 0,
  fancyCounter: 0,
  fancyInfo: {},
  fancyList: [],
  fancyDeleted: 10000,
};

// getters
const getters = {
  fancyBusy: stateFreezed => stateFreezed.fancyBusy,
  fancyList: stateFreezed => stateFreezed.fancyList,
  fancyInfo: stateFreezed => stateFreezed.fancyInfo,
  fancyCounter: stateFreezed => stateFreezed.fancyCounter,
  fancyDeleted: stateFreezed => stateFreezed.fancyDeleted,
};

/* eslint-disable */

// actions
const actions = {
  fetchFancyList({ commit }, tag) {
    commit(types.FANCY_LIST_BUSY, true);
    const hasTag = tag && tag !== '';
    const filterTag = hasTag ? `&tag=${tag}` : '';

    Vue.http.get(`refs/uploaded/?offset=${state.fancyOffset}${filterTag}`)
    .then((response) => {
      if (response.body.results) {
        commit(types.RECEIVE_FANCY_LIST, response.body);
        commit(types.FANCY_LIST_OFFSET);
        if (response.body.next) commit(types.FANCY_LIST_BUSY, false);
        if (!hasTag) {
          commit(types.UPDATE_FANCY_COUNTER, response.body.count);
        }
      }
    });
  },

  fetchFancyCounter({ commit }) {
    Vue.http.get('refs/uploaded/')
    .then((response) => {
      if (response.body.results) {
        commit(types.UPDATE_FANCY_COUNTER, response.body.count);
      }
    });
  },
  approveFancy({ commit, dispatch }, params) {
    Vue.http.put(`refs/uploaded/${params.id}/approve_and_estimate_by_tema/`, { estimation: params.estimation }, { emulateJSON: true })
    .then((response) => {
      dispatch('changeTagRef', { id: response.body.id, tags: params.tags });
      commit(types.UPDATE_FANCY_LIST, params.number);
    });
  },
  deleteFancy({ commit, dispatch, state }, params) {
    Vue.http.delete(`refs/uploaded/${params.id}/`);
    commit(types.UPDATE_FANCY_LIST, params.number);
    commit(types.UPDATE_FANCY_COUNTER, state.fancyCounter - 1);
  },
  deleteAllFancies({ commit, dispatch }, params) {
    Vue.http.delete(`refs/uploaded/${params.id}/`)
    .then(() => {
      commit(types.DELETED_FANCY_DONE);
      commit(types.UPDATE_FANCY_COUNTER, state.fancyCounter - 1);
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_FANCY_LIST](stateFreezed, fancyFetched) {
    const st = stateFreezed;
    st.fancyInfo = fancyFetched;
    st.fancyList = st.fancyList.concat(fancyFetched.results);
  },
  [types.UPDATE_FANCY_LIST](stateFreezed, key) {
    const st = stateFreezed;
    st.fancyList.splice(key, 1);
  },
  [types.FANCY_LIST_OFFSET](stateFreezed) {
    const st = stateFreezed;
    st.fancyOffset += 20;
  },
  [types.FANCY_LIST_BUSY](stateFreezed, status) {
    const st = stateFreezed;
    st.fancyBusy = status;
  },
  [types.DELETED_FANCY_LIST](stateFreezed, deleted) {
    const st = stateFreezed;
    st.fancyDeleted = deleted;
  },
  [types.DELETED_FANCY_DONE](stateFreezed) {
    const st = stateFreezed;
    st.fancyDeleted -= 1;
  },
  [types.CLEAR_FANCY_LIST](stateFreezed) {
    const st = stateFreezed;
    st.fancyBusy = false;
    st.fancyOffset = 0;
    st.fancyList = [];
  },
  [types.UPDATE_FANCY_COUNTER](stateFreezed, number) {
    const st = stateFreezed;
    st.fancyCounter = number;
  },
  [types.TAG_FANCY_UPDATE](stateFreezed, params) {
    const st = stateFreezed;
    const updatedList = st.fancyList;
    const updatedRef = st.fancyList[params.key];
    updatedRef.tags = [params.tag];
    Vue.set(updatedList, params.key, updatedRef);
    st.fancyList = updatedList;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/fancy.js